//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { LogoImage, LogoMobileImg, LogoImageJpStore } from '@cmp/images';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
import { mobileWidth, DEFAULT_WIDTH } from '@helpers/constants/window';
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------

class Logo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: DEFAULT_WIDTH,
    };
  }

  componentDidMount() {
    this.setState({ width: window.innerWidth });
  }

  render() {
    const { className, wrapperClassName, t } = this.props;
    const { width } = this.state;

    const componentClasses = classNames(styles.Logo, {
      [className]: className,
    });

    return (
      <Link to="/" className={wrapperClassName}>
        {t('trust_arc_locale') === 'ja' ? (
          <LogoImageJpStore
            className={componentClasses}
            alt={t('header_Logo')}
          />
        ) : width < mobileWidth ? (
          <LogoMobileImg alt={t('header_Logo')} />
        ) : (
          <LogoImage className={componentClasses} alt={t('header_Logo')} />
        )}
      </Link>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Logo);
